<template>
  <component :is="list.skipCardLayout?'div':'md-card'">
    <md-card-header class="md-card-header-icon md-card-header-green list-header" :class="list.hideListHeader? 'list-header-hidden' : ''">
      <template v-if="!list.hideListHeader">
        <h4 class="title">{{ list.pageTitle }}</h4>
      </template>

      <button v-if="!list.skipCardLayout && list.linkActive" v-on:click="newRecordLink()" class="md-button md-primary md-sm" style="float:right;margin-left:5px">Link<md-icon class="md-small">link</md-icon></button>
      <button v-if="!list.skipCardLayout && !list.hideNewRecordButton" v-on:click="newRecord()" class="md-button md-primary md-sm" style="float:right">Add<md-icon class="md-small">control_point</md-icon></button>

      <md-button v-if="!list.hideRefreshIcon" id="messageListRefresh" class="md-just-icon md-simple" @click="refresh()"><md-icon>refresh</md-icon></md-button>
    </md-card-header>
    <component :is="list.skipCardLayout?'div':'md-card-content'">

      <div class="dynamicList-loading"
           v-show="isPromisePending">
        <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
      </div>

      <template v-if="list.showTeamTitle && list.tableData && list.tableData.length && list.tableData[0].team">
        <h4 class="teamTitle">{{list.tableData[0].team}}</h4>
      </template>

      <md-table
        :value="queriedData"
        :md-sort.sync="list.currentSort"
        :md-sort-order.sync="list.currentSortOrder"
        :md-sort-fn="customSort"
        class="paginated-table table-striped table-hover"
        :class="list.tableClassName"
      >
        <md-table-toolbar v-if="!list.hideTableToolbar" class="hide-overflow">
          <md-field v-if="!list.searchRecordsInput" class="_uiKitInput">
            <label>Search</label>
            <md-input
              type="search"
              class="mb-3"
              clearable
              style="width: 200px"
              placeholder="Search records"
              v-model="searchQuery"
            >
            </md-input>
          </md-field>

          <md-field v-if="!list.recordsPerPageInput" class="_uiKitInput _perPageInput">
            <label for="pages">Per page</label>
            <md-select v-model="list.pagination.perPage" name="pages">
              <md-option
                v-for="item in list.pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
                {{ item }}
              </md-option>
            </md-select>
          </md-field>

        </md-table-toolbar>

        <!-- Table headings -->
        <md-table-row class="title-color">
          <md-table-head :key="'empty'"></md-table-head>
          <template v-for="(column, key) in list.columns">
              <md-table-head 
                :key="key" 
                class="head-cursor"
                @click.stop.native="column.sortable ? onSort(key) : null"
                @mouseenter.native="column.sortable ? hover = key : hover = ''"
                @mouseleave.native="column.sortable ? hover = '' : hover = ''" 
              >{{column.label}} 
                <md-icon
                  v-if="(column.sortable && hover === key) || lastSortByKey === key" 
                  class="md-icon-image md-theme-demo-light md-table-sortable-icn"> 
                  {{lastSortByKey === key ? (lastSortByOrder === "asc" ? 'arrow_upward' : 'arrow_downward') : 'arrow_upward'}} 
                </md-icon>
              </md-table-head>
          </template>
          <md-table-head :key="'empty1'" class="md-head-cell">Actions</md-table-head>
        </md-table-row>

        <template v-for="item in queriedData">
          <!-- Parent Row -->
          <md-table-row :key="item.id" @click.stop.native="list.linkRows? ( list.redirectNested? handleRedirectNested(item) : handleEdit(item) ) : false" :style="list.linkRows? 'cursor:pointer;' : ''">
            <template>
              <md-table-cell :key="item.id">
                <md-button 
                  class="btn-childItem" 
                  v-if="(item.isParentProduct || item.isFirstLevelParent)" 
                  @click.stop.native="toggle(item)"
                >
                  <md-icon v-if="opened.includes(item.id)">keyboard_arrow_down</md-icon>
                  <md-icon v-else>keyboard_arrow_up</md-icon>
                </md-button>
              </md-table-cell>
            </template>

            <template v-for="(column, name) in list.columns">
                <template v-if="list.linkConfigs && list.linkConfigs.length && getLinkConfig(column, name)">
                <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">
                    <a :href="callLinkHrefCallback(column, name, item)">
                    {{ callLinkTitleCallback(column, name, item) }}
                    </a>
                </md-table-cell>
                </template>
                <template v-else-if="list.HyperLinkColumns && list.HyperLinkColumns.colName === name">
                <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">
                    <a :href="getCaseHref(list.HyperLinkColumns, item)">
                    {{ getColumnDisplayValue(column, item, name) }}
                    </a>
                </md-table-cell>
                </template>
                <template v-else>
                <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">{{ getColumnDisplayValue(column, item, name) }}</md-table-cell>
                </template>
            </template>
            <md-table-cell md-label="Actions" v-if="!list.hideItemActions">
                <template v-for="(action) in list.itemActions">
                <!-- Show delete option only if user is Admin -->
                <md-button
                    v-if="(!item.level && $Session.isAdminGroupMember || 
                        (!$Session.isAdminGroupMember && 
                        (action.click != 'handleDelete' && (!item.level && action.click != 'handleDelete')))) ||
                        ($Session.isAdminGroupMember && item.level && action.click == 'handleDelete')"
                    :key="action.icon"
                    :class="item.added? action.classAdded : action.class"
                    @click.stop.native="callItemAction(action.click, item)"
                >
                    <md-icon>{{item.added? action.iconAdded : action.icon}}</md-icon>
                </md-button>
                </template>
            </md-table-cell>
          </md-table-row>

          <!-- Child Row -->
          <template 
            v-for="(childItem, childKey) in (item.children ? item.children.items : [])" 
            v-show="(item.children ? item.children.items.length : 0) > 0 ? true : false"
            >
            <md-table-row 
              class="level1"
              :key="childItem.child.id + 'Level-1'" 
              v-if="opened.includes(item.id)" 
              @click.stop.native="list.linkRows ? (list.redirectNested ? handleRedirectNested(childItem.child) : handleEdit(childItem.child)) : false" 
              :style="list.linkRows? 'cursor:pointer;' : ''"
            >
              <template>
                <md-table-cell :key="childKey">
                  <md-button 
                    class="btn-childItem" 
                    v-if="((childItem.child && childItem.child.children) ? childItem.child.children.items.length : 0) > 0" 
                    @click.stop.native="toggle1(childItem.child.id)"
                  >
                    <md-icon v-if="opened1.includes(childItem.child.id)">keyboard_arrow_down</md-icon>
                    <md-icon v-else>keyboard_arrow_up</md-icon>
                  </md-button>
                </md-table-cell>
              </template>
              
                <!-- md-selectable="multiple" -->
                <template v-for="(column, name) in list.columns">
                    <template v-if="list.linkConfigs && list.linkConfigs.length && getLinkConfig(column, name)">
                    <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">
                        <a :href="callLinkHrefCallback(column, name, childItem.child)">
                        {{ callLinkTitleCallback(column, name, childItem.child) }}
                        </a>
                    </md-table-cell>
                    </template>
                    <template v-else-if="list.HyperLinkColumns && list.HyperLinkColumns.colName === name">
                    <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">
                        <a :href="getCaseHref(list.HyperLinkColumns, childItem.child)">
                        {{ getColumnDisplayValue(column, childItem.child, name) }}
                        </a>
                    </md-table-cell>
                    </template>
                    <template v-else>
                      <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">{{ getColumnDisplayValue(column, childItem.child, name) }}</md-table-cell>
                    </template>
                </template>
                <md-table-cell md-label="Actions" v-if="!list.hideItemActions">
                    <template v-for="(action) in list.itemActions">
                    <!-- Show delete option only if user is Admin -->
                    <md-button
                        v-if="(!childItem.level && $Session.isAdminGroupMember || 
                            (!$Session.isAdminGroupMember && 
                            (action.click != 'handleDelete' && (!childItem.level && action.click != 'handleDelete')))) ||
                            ($Session.isAdminGroupMember && childItem.level && action.click == 'handleDelete')"
                        :key="action.icon"
                        :class="childItem.added? action.classAdded : action.class"
                        @click.stop.native="callItemAction(action.click, childItem.child)"
                    >
                        <md-icon>{{childItem.added? action.iconAdded : action.icon}}</md-icon>
                    </md-button>
                    </template>
                </md-table-cell>

            </md-table-row>

            <!-- Sub Child Row -->
            <template 
              v-for="(subChildItem, subChildKey) in ((childItem.child && childItem.child.children) ? childItem.child.children.items : []) " 
              v-show="((childItem.child && childItem.child.children) ? childItem.child.children.items.length : 0) > 0 ? true : false"
              >
              <md-table-row 
                class="level2" 
                :key="subChildItem.child.id + 'Level-2'" 
                v-if="opened1.includes(childItem.child.id)" 
                @click.stop.native="list.linkRows ? (list.redirectNested ? handleRedirectNested(subChildItem.child) : handleEdit(subChildItem.child)) : false" 
                :style="list.linkRows? 'cursor:pointer;' : ''"
              >
                <template>
                  <md-table-cell :key="subChildKey"></md-table-cell>
                </template>
                <!-- md-selectable="multiple" -->
                <template v-for="(column, name) in list.columns">
                    <template v-if="list.linkConfigs && list.linkConfigs.length && getLinkConfig(column, name)">
                        <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">
                            <a :href="callLinkHrefCallback(column, name, subChildItem.child)">
                                {{ callLinkTitleCallback(column, name, subChildItem.child) }}
                            </a>
                        </md-table-cell>
                    </template>
                    <template v-else-if="list.HyperLinkColumns && list.HyperLinkColumns.colName === name">
                        <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">
                            <a :href="getCaseHref(list.HyperLinkColumns, subChildItem.child)">
                                {{ getColumnDisplayValue(column, subChildItem.child, name) }}
                            </a>
                        </md-table-cell>
                    </template>
                    <template v-else>
                        <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">{{ getColumnDisplayValue(column, subChildItem.child, name) }}</md-table-cell>
                    </template>
                </template>
                <md-table-cell md-label="Actions" v-if="!list.hideItemActions">
                    <template v-for="(action) in list.itemActions">
                    <!-- Show delete option only if user is Admin -->
                    <md-button
                        v-if="(!subChildItem.level && $Session.isAdminGroupMember || 
                            (!$Session.isAdminGroupMember && 
                            (action.click != 'handleDelete' && (!subChildItem.level && action.click != 'handleDelete')))) ||
                            ($Session.isAdminGroupMember && subChildItem.level && action.click == 'handleDelete')"
                        :key="action.icon"
                        :class="subChildItem.added? action.classAdded : action.class"
                        @click.stop.native="callItemAction(action.click, subChildItem.child)"
                    >
                        <md-icon>{{subChildItem.added? action.iconAdded : action.icon}}</md-icon>
                    </md-button>
                    </template>
                </md-table-cell>
              </md-table-row>
            </template>

          </template>
        </template>
        </md-table>

    </component>
    
    <md-card-actions md-alignment="space-between">
      <div class="">
        <p v-if="queriedData.length" class="card-category number">
          Showing {{ from + 1 }} to {{ to }} of{{list.nextToken? ' more than': ''}} {{ total }} records
        </p>
        <p v-else class="card-category">
          0 results
        </p>
      </div>

      <!--[i] If you look at pagination component,
      you will see that nextPage and prevPage functions both emit a change to the model value which is currentPage.
      this will kick off another search-->
      <pagination
        class="pagination-no-border pagination-success"
        v-model="currentPage"
        :per-page="list.pagination.perPage"
        :nextToken="list.nextToken"
        :total="total"
        v-on:loadMore="loadMore()"
      >
      </pagination>
    </md-card-actions>

    <!-- ATLAS-681 ElasticSearch error - no results - Alert Dialog -->
    <md-dialog-alert
      class="__alertDialog"
      :md-active.sync="mdAlertDialogShow"
      :md-title="mdAlertTitle"
      :md-content="mdAlertMessage" />
  </component>
</template>

<script>
  import { Pagination } from "@/components";
  import Fuse from "fuse.js";
  import Swal from "sweetalert2";

  import Amplify, { Auth, API, graphqlOperation } from 'aws-amplify';
  import * as queries from '@/graphql/queries';
  import * as queries_custom from '@/graphql/queries_custom';
  import * as mutations from '@/graphql/mutations';
  import * as subscriptions from '@/graphql/subscriptions';
  import searchConfig from '@/searchConfig';
  import aws_exports from "../../aws-exports"; 
  import AWS from 'aws-sdk';
    import gql from "graphql-tag";

  export default {
    props: {
      list: {
        type: Object,
        required: true
      },
      filter: {
        type: Object
      },
      params: {
        type: Object
      },
      relateRecordInput: {
        type: Object
      },
      relateRecordInputField: {
        type: String
      },
      assigneeFilters : {
        type: Array,
        default: () => [],
      }
    },
    components: {
      Pagination
    },
    data() {
      return {
        searchQuery: "",
        searchTimeout: null,
        isPromisePending: false,
        currentPage: 1,
        searchConfig: searchConfig,
        mdAlertTitle: "",
        mdAlertMessage: "",
        mdAlertDialogShow: false,
        lastSortByKey: "createdAt",
        lastSortByOrder: "desc",
        opened: [],
        opened1: [],
        hover: "",
      };
    },
    apollo: {
      subscriptions: {
        query: function() {
          return gql(queries['searchUsers']);
        },
        variables: {
          filter: { id: { eq: '-1' } },
          limit: 1,
        },
        update: () => [],
      }
    },
    watch: {
      /**
       * Searches through the table data by a given query.
       * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
       * @param value of the query
       */
      searchQuery(value) {
        let result = [];

        // if we don't have backup of original source data then create one
        if (!this.list.sourceData || !this.list.sourceData.length) {
          this.list.sourceData = this.list.tableData;
        }

        // populate our result with backup data
        if (this.list.sourceData && this.list.sourceData.length) {
          result = this.list.sourceData;
        }

        // populate our result with assigneeFilters data for Dashboard >> teamsTab 
        if (this.list.searchForFilteredData && this.list.filteredData) {
          result = this.list.filteredData;
        }

        // if we have search query and columns to search for then lookup query
        // using Fuse.js
        if (
          value !== "" && 
          this.sortableColumnNames && 
          this.sortableColumnNames.length
        ) {
          //result = this.list.fuseSearch.search(this.searchQuery);
          /**
           * Fuse.js matching options doc
           * @link https://fusejs.io/api/options.html#fuzzy-matching-options
           */
          const fuse = new Fuse(result, {
            keys: this.sortableColumnNames,
            threshold: 0.1
          });
          result = fuse.search(this.searchQuery);
        }

        // update table data with search results
        this.list.tableData = result;

        // if (value !== "") {
        //   result = this.list.fuseSearch.search(this.searchQuery);
        //
        //   this.searchTimeout = setTimeout(() => {
        //     this.search(this.searchQuery)
        //       .then(response => {
        //         this.list.searchedData = response;
        //         this.$c.log("searchQuery(" + this.searchQuery + ") result:", response);
        //       })
        //   }, 350);
        //
        // } else {
        //   this.list.searchedData = result;
        // }
      },
      currentPage(newVal, oldVal) {
        // this.search(this.searchQuery)
        //   .then(response => {
        //     //this.list.searchedData = response;
        //     //  this.data[listName].items =  [...this.data[listName].items, ...response];
        //     /** Add the next page's results to our tableData */
        //     this.list.tableData =  [...this.list.tableData, ...response];
        //     this.$c.log("searchQuery(" + this.searchQuery + ") result:", response);
        //   })
      },
      'dataNeedsUpdate' (to) {
        if (to === true) {
          this.refresh();
        }
      },

      'assigneeFilters': {
        immediate: true,
        handler: function() {
          if (!this.list.sourceData) {
            this.list.sourceData = this.list.tableData;
          }
          let result = [];
          const fuse = new Fuse(this.list.sourceData, {
            keys: ['assignee'],
            threshold: 0.0
          });
          this.assigneeFilters.map(_filter => {
            result = result.concat(fuse.search(_filter));
          });
          this.list.tableData = result;
          this.list.filteredData = result;          
        },
      },
      /**
       * Refresh list when per page count changed
       */
      'list.pagination.perPage'  (newValue, oldValue) {
        if (newValue === oldValue) {
          return;
        }
        this.refresh();
      },
    },
    computed: {
      dataNeedsUpdate: function () {
        return this.list.refreshData;
      },

      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.list.tableData;
        if (this.list.searchedData.length > 0) {
          this.$c.log("queriedData() using searchedData");
          result = this.list.searchedData;
        }
        return result.length? result.slice(this.from, this.to) : [];
      },
      to() {
        let highBound = this.from + this.list.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.list.pagination.perPage * (this.currentPage - 1);
      },
      total() {
        return this.list.searchedData.length > 0
          ? this.list.searchedData.length
          : this.list.tableData.length;
      },
      sortableColumnNames() {
        let columns = [];
        this.$loopo(this.list.columns, (value, key) => {
          if (value.sortable) columns.push(key);
        });
        this.$c.log(this.list.pageTitle + " sortableColumnNames: ", columns);
        return columns;
      },
      displayColumns() {
        let columns = [];
        this.$loopo(this.list.columns, (value, key) => {
          if (value.display) columns.push(value);
        });
        this.$c.log(this.list.pageTitle + " displayColumns: ", columns);
        return columns;
      }
    },
    methods: {
      toggle(item) {
        const index = this.opened.indexOf(item.id);
        if (index > -1) {
          this.opened.splice(index, 1)
        } else {
          this.opened.push(item.id)
        }
        if (item.children) {
          item.children.items.forEach((el) => {
            const index = this.opened1.indexOf(el.child.id);
            if (index > -1) {
              this.opened1.splice(index, 1)
            } 
          })
        }
      },
      toggle1(id) {
        const index = this.opened1.indexOf(id);
        if (index > -1) {
          this.opened1.splice(index, 1)
        } else {
          this.opened1.push(id)
        }
      },
      /**
      * Sorting table data manually in Colapsible List
      */
      onSort(key) {
        let result = this.list.tableData;
        let lastSortKey = this.lastSortByKey
        this.lastSortByKey = key;
        let currentSortBy = "asc";
        if (lastSortKey === key) {
            if (this.lastSortByOrder === "asc") {
            currentSortBy = "desc";
            }else {
                currentSortBy = "asc";
            }
        }
        const sortBy = key;
        this.lastSortByOrder = currentSortBy;
        return result.sort((a, b) => {
            let aSortBy = typeof a[sortBy] !== "undefined" && a[sortBy] !== null? a[sortBy] : "";
            let bSortBy = typeof b[sortBy] !== "undefined" && b[sortBy] !== null? b[sortBy] : "";
            if (currentSortBy === "desc") {
            return bSortBy.localeCompare(aSortBy);
            }
            return aSortBy.localeCompare(bSortBy);
        });
      },
      getLinkConfig(column, name) {
        return this.list.linkConfigs.find(_column => _column.name == name);
      },
      callLinkHrefCallback(column, name, item) {
        const config = this.getLinkConfig(column, name);
        if (config && 'function' == typeof config.hrefCallback) {
          return config.hrefCallback(column, name, item);
        }
      },
      callLinkTitleCallback(column, name, item) {
        const config = this.getLinkConfig(column, name);
        if (config && 'function' == typeof config.titleCallback) {
          return config.titleCallback(column, name, item);
        }
      },
      callItemAction(funcName, item) {
        if (typeof this[funcName] === 'function') {
          return this[funcName](item);
        }
      },
      getCaseHref(listColumns, item) {
        const path = '#/' + listColumns.editColLink + '/' + item[listColumns.fieldId] + '?tab=' + listColumns.tabName;
        return path;
      },
      async loadMore() {
        this.$c.log('loadMore()...');

        this.search(this.searchQuery, true)
          .then(response => {
            if (!response.length) {
              this.$c.log('loadMore() End of results reached');
            } else {
              this.$c.log('loadMore() Response:', response);
              /** Add the next page's results to our tableData */
              this.list.tableData =  [...this.list.tableData, ...response];
              this.$c.log('loadMore() Incrementing currentPage:', this.currentPage);
              let targetPage = this.currentPage + 1;

              // Fuse search initialization.
              this.list.fuseSearch = new Fuse(this.list.tableData, {
                keys: this.sortableColumnNames,
                threshold: 0.3,
              });

              //TODO: Hook up to fuse.js event if possible
              // Using a timeout for now. :/
              this.$nextTick(() => {
                setTimeout(() => {
                  this.currentPage = targetPage;
                  this.$c.log('LOADING MORE Incrementing currentPage verify:', this.currentPage);
                }, 250);
              });
            }
          });
      },
      async refresh() {
        this.$c.log('refresh has been called')
        this.currentPage = 1;
        const result = await this.search();
        this.list.tableData = result;
        this.list.refreshData = false;
      },
      getColumnDisplayValue(column, item, name) {
        let result = '';
        if (typeof item === 'undefined' || typeof item[name] === 'undefined') return result;

        if (typeof column.nested !== 'undefined' && item[name]) {
            if (typeof column.nested === 'object') {
              column.nested.forEach((value) => {
                result += ( (item[name] && item[name][value])? (item[name][value] + ' ') : ' ');
              });
            } else {              
                result = item[name][column.nested] ? item[name][column.nested] : '';
            }
        } else if(column.displayColumn && item[column.displayColumn]) {
          //if item has displayColumn field then show it
          result = item[column.displayColumn];
        } else {
          result = item[name];
        }

        if(result === null){        
          result = '';
        }
        
        return result;
      },
      getSearchConfig() {
        const listQueryId = this.list.listQueryId;
        let objectName = listQueryId.substring(0, listQueryId.length - 1).replace('list', '');
        return this.searchConfig[objectName];
      },
      async delete(item) {
        this.isPromisePending = true;
        
        if(this.list.deleteQueryId == 'deleteTeamUser') {
          if (item[this.list.userGroupId] != null) {
            let groupIdField = item[this.list.userGroupId].replace(/\s+/g, '_');

            /**
             * ATLAS-730 Teams CRUD: Users Tab - Change list query to search query
             * Set given_name as name in delete message
             */
            if(item && item.given_name) {
              item.name = item.given_name;
            }
            
            var params = {
              GroupName: groupIdField, /* required */
              UserPoolId: aws_exports.aws_user_pools_id, /* required */
              Username: item.email
            };
            console.log('Cognito add team params:', params);
            Promise.resolve(Auth.currentAuthenticatedUser())
              .then(user =>
                Auth.currentCredentials()
                    .then(credentials =>
                      Promise.resolve(
                        new AWS.CognitoIdentityServiceProvider({
                          apiVersion: '2016-04-18',
                          credentials: Auth.essentialCredentials(credentials),
                          region: aws_exports.aws_appsync_region
                        })
                      )
                    )
                    .then(client => {
                      var responceGroupData = client.adminRemoveUserFromGroup(params).promise();
                      console.log('Responce of delete user from group', responceGroupData);
                    })
                    .catch(err => {
                      console.log('Error to delete user from Group', err);
                    })
            )
          }
        }

        let idField = 'id';
        if (typeof this.list.deleteQueryIdField !== 'undefined') {
          idField = this.list.deleteQueryIdField;
        }

        this.$c.log(this.list.pageTitle + " deleting record:", item[idField]);
        await API.graphql(graphqlOperation(mutations[this.list.deleteQueryId], {input: {"id": item[idField]}}))
          .then(this.afterDelete(item))
          .catch(error => {
            this.$c.log(this.list.pageTitle + " delete record error:", error);
          });
      },
      async deleteLink(item) {
        let idField = 'id';
        if (typeof this.list.updateQueryIdField !== 'undefined') {
          idField = this.list.updateQueryIdField;
        }
        let input = {};
        input['id'] = item.id ;
        input[this.list.updateQueryIdField] = null;

        await API.graphql(graphqlOperation(mutations[this.list.updateQueryId], {input: input}))
          .then(this.afterDelete(item))
          .catch(error => {
            this.$c.log(this.list.pageTitle + " delete record error:", error);
          });

      },
      async add(item) {
        this.$c.log(this.list.pageTitle + " adding record:", item.id);

        let input = this.relateRecordInput;
        input[this.relateRecordInputField] = item.id;

        await API.graphql(graphqlOperation(mutations[this.list.createMutationId], {input: input}))
          .then(this.afterAdd(item))
          .catch(error => {
            this.$c.log(this.list.pageTitle + " adding record error:", error);
          });
      },
      afterAdd(item) {
        this.$c.log(this.list.pageTitle + " add record success!");
        item.added = true;
        setTimeout(() => {
          this.$emit('relationshipAdded', item);
          this.deleteRow(item);
        }, 500)
      },
      afterDelete(item) {
        this.$c.log(this.list.pageTitle + " delete record success!");
        this.deleteRow(item);
        this.isPromisePending = false;
        Swal.fire({
          title: "Deleted",
          text: `You deleted ${item.name}`,
          type: "success",
          confirmButtonClass: "md-button md-success btn-fill",
          buttonsStyling: false
        });
      },
      newRecord() {
        if (typeof this.list.showRelatedDialog !== 'undefined') {
          this.list.showRelatedDialog = true;
          return;
        }

        if (typeof this.filter === 'undefined') {
          this.$router.push("/" + this.list.editPath + '/new');
        } else {
          this.$loopo(this.filter, (item, name) => {
            this.$router.push("/" + this.list.editPath + '/new?' + name + '=' + item.eq);
          });
        }
      },
      newRecordLink() {
        if (typeof this.list.showRelatedLinkDialog !== 'undefined') {
          this.list.showRelatedLinkDialog = true;
          return;
        }

        if (typeof this.filter === 'undefined') {
          this.$router.push("/" + this.list.editPath + '/new');
        } else {
          this.$loopo(this.filter, (item, name) => {
            this.$router.push("/" + this.list.editPath + '/new?' + name + '=' + item.eq);
          });
        }
      },
      customSort(value) {
        /**
         * ATLAS-745 AT-I-7 Service -> Children products need to be displayed 
         * UNDER their parent product
         * 
         * If isDirectTableSortDisabled is true, disable in table sorting
         */
        if (true === this.list.isDirectTableSortDisabled) {
          return;
        }

        return value.sort((a, b) => {
          const sortBy = this.list.currentSort;
          let aSortBy = typeof a[sortBy] !== "undefined" && a[sortBy] !== null? a[sortBy] : "";
          let bSortBy = typeof b[sortBy] !== "undefined" && b[sortBy] !== null? b[sortBy] : "";
          if (this.list.currentSortOrder === "desc") {
            return aSortBy.localeCompare(bSortBy);
          }
          return bSortBy.localeCompare(aSortBy);
        });
      },
      handleEdit(item) {
        this.$router.push({ path: "/" + this.list.editPath + "/" + item.id});
      },
      handleAdd(item) {
        this.add(item);
      },
      handleLinkDelete(item) {
        //build the name first
        let nameFields = this.list.deleteMessageNameFields ? this.list.deleteMessageNameFields : ['name'];
        let objectName = '';
        nameFields.forEach((nf, index) => {
          objectName += item[nf];
          if (index !== nameFields.length -1) objectName += ' ';
        });

        // without at least 1 character this will use the default on the right
        let title = this.list.deleteMessageTitle ? this.list.deleteMessageTitle : "Are you sure you want to delete {objectName}?";
        title = title.replace('{objectName}', objectName);

        //this test is different because we want to allow config of '' to omit the default text
        let text = typeof this.list.deleteMessageText !== 'undefined' ? this.list.deleteMessageText : `The change cannot be undone.`;

        Swal.fire({
          title: title,
          text: text,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "Yes",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.deleteLink(item);
          }
        });
      },
      
      handleDelete(item) {
  
        //build the name first
        let nameFields = this.list.deleteMessageNameFields ? this.list.deleteMessageNameFields : ['name'];
        let objectName = '';
        nameFields.forEach((nf, index) => {
          objectName += item[nf];
          if (index !== nameFields.length -1) objectName += ' ';
        });

        // without at least 1 character this will use the default on the right
        let title = this.list.deleteMessageTitle ? this.list.deleteMessageTitle : "Are you sure you want to delete {objectName}?";
        title = title.replace('{objectName}', objectName);

        //this test is different because we want to allow config of '' to omit the default text
        let text = typeof this.list.deleteMessageText !== 'undefined' ? this.list.deleteMessageText : `The change cannot be undone.`;

        Swal.fire({
          title: title,
          text: text,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "Yes",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            if (typeof this.list.linkActive !== 'undefined' && (this.list.linkActive == true)) {
              this.deleteLink(item);
            } else {
              this.delete(item);
            }
          }
        });
      },
      deleteRow(item) {
        this.$emit('deleteRow', item);
        let indexToDelete = this.list.tableData.findIndex(
          tableRow => tableRow.id === item.id
        );
        if (indexToDelete >= 0) {
          this.list.tableData.splice(indexToDelete, 1);
        }
      },
      async search(searchString, useNextToken) {
        const listQueryId = this.list.listQueryId;
        const listQueryTarget = this.list.listQueryTarget;
        this.$c.log(listQueryId + " search(" + searchString + ")");

        const searchMethod = listQueryId.substring(0, 6) === 'search'? 'wildcard' : 'contains';
        
        /**
         * ATLAS-578 Teams CRUD : Added Team members are not showing properly
         * perPageMaxLimit is added to fix the data return limit
         */
        let params = {};
        if(this.list.pagination.perPageMaxLimit) {
          params = {
            "limit": this.list.pagination.perPageMaxLimit
          };
        } else {
          params = {
            "limit": this.list.pagination.perPage
          };
        }

        if (useNextToken && this.list.nextToken) {
          params.nextToken = this.list.nextToken;
        }

        let filters = [], operation;

        //if (typeof searchString !== 'undefined' && searchString !== "" && this.list.searchFields) {
        if (typeof searchString !== 'undefined' && searchString !== "") {
          let searchConfig = this.getSearchConfig();

          searchConfig.searchFields.forEach((searchField) => {
            let test = {};
            test[searchField] = {};//{contains: searchString};
            test[searchField][searchMethod] = '*' + searchString + '*';
            filters.push(test);
          });
        }
        this.$c.log(listQueryId + " search(" + searchString + ") filters: ", filters);

        if (typeof this.filter !== 'undefined') {
          //filters.push(this.list.filter);
          if (filters.length > 1) {
            params.filter = {and: [
                this.filter,
                {or: filters}
              ]};
          } else if (filters.length === 1) {
            params.filter ={and: [
                this.filter,
                filters[0]
              ]};
          } else {
            params.filter = this.filter;
          }
        } else {
          if (filters.length > 1) {
            params.filter = {or: filters};
          } else if (filters.length === 1) {
            params.filter = filters[0];
          }
        }

        if (typeof this.params !== 'undefined') {
          this.$loopo(this.params, (param, paramName) => {
            params[paramName] = param;
          });
        }

        this.$c.log(listQueryId + " search(" + searchString + ") params: ", params);

        //Get the correct query
        let query = queries[listQueryId];
        if (typeof query === 'undefined') {
          query = queries_custom[listQueryId];
        }


        operation = graphqlOperation(query, params);

        this.$c.log(listQueryId + " search(" + searchString + ") operation: ", operation);

        this.isPromisePending = true;

        const result = await API.graphql(operation);
        this.$c.log(listQueryId + " search(" + searchString + ") Results Raw:", result.data);
        let response = false;
        let target = listQueryTarget ? listQueryTarget : listQueryId;


        if (result.data && result.data[target]) {
          let data = result.data[target];
          this.$c.log('oldNextToken: [' + this.list.nextToken + ']');
          this.$c.log('newNextToken: [' + data.nextToken + ']');

          if (data.nextToken !== this.list.nextToken) {
            this.list.nextToken = data.nextToken;
          } else {
            this.list.nextToken = false;
          }
          if (typeof this.list.formatResponse === 'function') {
            response = this.list.formatResponse(result.data);
          } else if (data.items) {
            response = data.items;
          }
        }

        /**
         * ATLAS-681 ElasticSearch error - no results
         * Show alert dialog
         * 
         * ATLAS-793 Getting Error Screen when no data found
         * Hide alert dialog
         */
        if (typeof result.errors !== 'undefined' && result.errors.length) {
            this.$c.log(result);
            let skipError = "Elasticsearch responded with an error: Not Found";
            let errorMsg = result.errors[0].message;

            if (errorMsg && !errorMsg.includes(skipError)) {
              this.mdAlertTitle = "Error";
              this.mdAlertMessage = "Search Error, reload the page";
              this.mdAlertDialogShow = true;
            }
        }
        
        // if number of items returned is less than current page limit
        // then unset nextToken
        if (result.data[target].items.length < this.list.pagination.perPage) {
          this.list.nextToken = null;
        }

        this.$c.log(listQueryId + " search(" + searchString + ") Results Formatted:", response);
        this.isPromisePending = false;
        return response;
      },
      /**
       * ATLAS-745 AT-I-7 Service -> Children products need to be displayed UNDER their parent product
       */
      toggleChildRecord(item) {
        item.showChild = !item.showChild;
        let childIds = [];

        //child item scan
        item.children.items.forEach((el) => {
          childIds.push(el.child.id);
        });

        this.list.tableData.forEach((td) => {
          if(-1 == childIds.indexOf(td.id)) return;

          let levelString = td.level;
          if (!levelString) {
            levelString = "";
          }
          let classNames = levelString.split(' ');
          if(item.showChild) {
            let hiddenIndex = classNames.findIndex(className => {
              return 'hidden' == className;
            });
            if(-1 != hiddenIndex) {
              classNames.splice(hiddenIndex, 1);
            }
            
          } else {
            classNames.push('hidden');
          }
          this.$set(td, 'level', classNames.join(' '));
        });
      }
    },
    async mounted() {
      //added condition to skip the API call
      if (this.list.isApiDisabled) {
        return;
      }

      if (this.list.tableData.length === 0 || this.list.forceMountedRefresh) {
        const result = await this.search();
        this.list.tableData = result;

        // Fuse search initialization.
        this.list.fuseSearch = new Fuse(this.list.tableData, {
          keys: this.sortableColumnNames,
          threshold: 0.3
        });

        this.$c.log(this.list.listQueryId + " mounted() this.list.tableData:", this.list.tableData);
      }

      // Fuse search initialization.
      // this.list.fuseSearch = new Fuse(this.list.tableData, {
      //   keys: this.sortableColumnNames,
      //   threshold: 0.3
      // });
      if (this.list.subscriptions) {
        this.$loopo(this.list.subscriptions, (sub, name) => {
          this.$c.log('SUBSCRIPTION CONFIGURED: ' + name);

          if (typeof subscriptions[name] === 'undefined') {
            this.$c.error('SUBSCRIPTION [' + name + '] not found!');
            return;
          }

          let thisFunc = this.list.subscriptions[name].function;
          this.$apollo.queries.subscriptions.subscribeToMore({
            document: gql(subscriptions[name]),
            updateQuery: (previousResult, { subscriptionData }) => {
              console.log('SUBSCRIPTION ', name, subscriptionData);
              thisFunc({ value: subscriptionData });
            },
          });
        });
      }
    },
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions{
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }

  .md-card-header.list-header.list-header-hidden {
    padding-top: 12px;
  }

  .dynamicList-loading {
    position: absolute;
    top: 20px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
  }
  
  .md-table-cell {
      overflow-wrap: break-word !important;
  }

  .md-dialog.__alertDialog.md-theme-default {
    width: 50% !important;
  }

  /* ATLAS-745 - Children Product row */
  .hidden {
    display: none !important;
  }
  tr.md-table-row.level1 {
    background-color: #E7E6E6;
  }
  tr.md-table-row.level2 {
    background-color: #C0C0C0;;
  }
  button.md-button.btn-childItem.md-theme-default {
    background-color: #fff !important;
    border: 1px solid #F6F2F2;
    border-radius: 4px;
  }
  .btn-childItem i.md-icon.md-icon-font.md-theme-default {
    color: #000 !important;
  }
  .md-icon {
    font-size: 17px !important;
  }
  .head-cursor {
    cursor: pointer;
  }
  .md-head-cell {
    padding-top: 7px;
  }
  .title-color {
    background-color: white !important;
  }
  .md-table-sortable-icn {
    position: absolute;
    top: 50%;
    right: -1px;
    transition: .3s cubic-bezier(.4,0,.2,1);
    transform: translateY(-50%);
    color: rgb(54, 54, 54) !important;
  }
  ._perPageInput {
    margin-left: auto;
  }
  ._noTableSort .head-cursor {
    cursor: default;
  }
  ._noTableSort .md-table-head-label .md-table-sortable-icn {
    display: none !important;
  }
</style>

<style>
  /* ATLAS-745 - Children Product row */
  button.md-button.btn-childItem.md-theme-default .md-ripple {
    padding: 0px !important;
  }
</style>